import localStorageIds from '../constants/localStorageIds'
import localStorageHelper from './localStorageHelper'

// The selected org's id: the org the Org-Id header carries, for routes that used to take it from there.
const selectedOrgId = () => localStorageHelper(localStorageIds.SELECTED_ORG).localStorageValue?.id

export default selectedOrgId
